<template>
  <div>
    <div
      ref="title"
      :style="`width:100%; height:${ height ? height : '500px' };`"
    ></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { optionLine } from '@/setting/ChartOptionLine'
export default {
  name: 'CountPerHoursChart',
  props: ['chartData', 'title', 'height'],
  mounted () {
    this.initChart()
  },
  watch: {
    option: {
      handler (val) {
        if (val) {
          try {
            this.chart.setOption(val)
          } catch (error) {
            // console.log('error', error)
          }
        }
      }
    }
  },
  computed: {
    lateOrderComp () {
      return this.chartData.map((i) => {
        return i.latesHour.late
      })
    },
    onTimeOrderComp () {
      return this.chartData.map((i) => {
        return i.latesHour.notLate
      })
    },
    successOrderComp () {
      return this.chartData.map((i) => {
        return i.successOrderHour
      })
    },
    setChartOption () {
      const localChart = { ...optionLine }
      localChart.legend = {
        data: ['Success Orders', 'On-Time', 'Late'],
        orient: 'horizontal'
      }
      localChart.series = [
        {
          name: 'Success Orders',
          data: this.successOrderComp,
          type: 'line',
          label: {
            show: true,
            position: 'top'
          }
          // areaStyle: {}
        },
        {
          name: 'On-Time',
          data: this.onTimeOrderComp,
          type: 'bar',
          stack: 'total'
          //   label: {
          //     show: true,
          //     position: 'top'
          //   }
        },
        {
          name: 'Late',
          data: this.lateOrderComp,
          type: 'bar',
          stack: 'total'
          //   label: {
          //     show: true,
          //     position: 'top'
          //   }
        }
      ]
      return localChart
    }
  },
  methods: {
    initChart () {
      this.chart = echarts.init(this.$refs.title)
      this.chart.setOption(this.setChartOption)
    }
  }
}
</script>
